<template>
  <div class="bb-link-on-proforma">
    <span>{{value}}</span>
    <div v-if="itemsData">
      <span v-for="(item, index) in items"
            :key="item._id"
            class="bb-link-on-proforma__link"
            @click="openProforma(item)"
      >
        {{item.cnNumber}}<span v-if="index !== items.length - 1 && items.length !== 1">,</span>
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'LinkOnProforma',
  props: ['column', 'row', 'index', 'items'],
  computed: {
    value: {
      get: function () {
        const prop = _.get(this.column, 'property', '')
        let value = _.get(this.row, prop, '')
        const regexp = _.get(this.column, 'regexp', '')
        return value.replace(regexp, '')
      }
    },
    itemsData () {
      return this.items.length
    }
  },
  methods: {
    openProforma (item) {
      this.$emit('openProforma', item)
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-link-on-proforma {
    position: relative;

    &__link {
      color: $color-accent;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/Table/LinkOnProforma/LinkOnProforma.vue